/* handling of DFP ads */
class Gpt {
  constructor(dfpID) {
    this.dfpID = dfpID;
    this.adUid = 0;
    window.googletag = window.googletag || { cmd: [] };

    return this.evaluate();
  }

  evaluate() {
    return (() => {
      let interstitialSlot;

      googletag.cmd.push(() => {
        //common setup
        const targetingConfig = {};
        if (window.adTargetingHash) {
          for (const key in window.adTargetingHash) {
            if (window.adTargetingHash[key])
              targetingConfig[key] = window.adTargetingHash[key];
          }
        }

        googletag.setConfig({
          singleRequest: true,
          collapseDiv: "ON_NO_FILL",
          lazyLoad: {
            fetchMarginPercent: 100,
            renderMarginPercent: 50,
            mobileScaling: 2.0,
          },
          safeFrame: {
            allowOverlayExpansion: false,
            allowPushExpansion: true,
            forceSafeFrame: true,
            sandbox: false,
          },
          targeting: targetingConfig,
        });

        // interstitialSlot = googletag.defineOutOfPageSlot(
        //   `/${this.dfpID}/${window.location.hostname.replace(/^www\./, "")}/interstitial_unit`,
        //   googletag.enums.OutOfPageFormat.INTERSTITIAL,
        // );

        if (interstitialSlot) {
          interstitialSlot.addService(googletag.pubads()).setConfig({
            interstitial: {
              triggers: {
                navBar: true,
                unhideWindow: true,
              },
            },
          });
        }
      });

      const pageAdSlots = Array.from($(".reklama"));
      const definedAdsIds = [];

      for (let slot of pageAdSlots) {
        const $slot = $(slot);
        definedAdsIds.push(this.defineSlot($slot));
      }

      googletag.cmd.push(() => {
        googletag.enableServices();
      });

      if (interstitialSlot)
        googletag.cmd.push(() => {
          googletag.display(interstitialSlot);
        });

      definedAdsIds.forEach((divId) => {
        googletag.cmd.push(() => {
          googletag.display(divId);
        });
      });
    })();
  }

  defineSlot($slot) {
    const unitCode = $slot.data("adunit");
    const dimensions = $slot.data("gam-dimensions");
    const testVariant = $slot.data("test-variant");
    const path = `/${this.dfpID}/${unitCode}`;
    //const path = "/6355419/Travel/Europe/France/Paris";
    let divId;

    if ($slot.attr("id")) {
      divId = $slot.attr("id");
    } else {
      //generate unique div id
      this.adUid++;
      divId =
        unitCode.replace(/[^A-z0-9]/g, "_") +
        "-moje-automaticke-id-" +
        this.adUid;
      $slot.attr("id", divId);
    }

    googletag.cmd.push(() => {
      const uniqueSizes = [
        ...new Set(dimensions.flatMap((d) => d[1]).map(JSON.stringify)),
      ].map(JSON.parse); //! bacha ak tieto sizes boli zle nezobrazovali sa mi reklamy nevedel som na to prist preco
      const sizeMapping = googletag.sizeMapping();
      dimensions.forEach((d) => {
        sizeMapping.addSize(d[0], d[1]);
      });

      const gpt_slot = googletag
        .defineSlot(path, uniqueSizes, divId)
        .defineSizeMapping(sizeMapping.build())
        .addService(googletag.pubads());

      const gptSlotConfig = {
        targeting: {
          zlavadna_location: $slot.data("gam-zlavadna-location"),
        },
      };
      gptSlotConfig.targeting["test_variant"] = testVariant || "none";
      gpt_slot.setConfig(gptSlotConfig);
    });
    return divId;
  }
}

$(function () {
  //return this.gpt || (this.gpt = new Gpt("162717810,21623627404")); //Takto to bolo s novym FatChilli oni mi tie cesty poslali hentak s tou ciarkou to musi byt
  return window.gpt || (window.gpt = new Gpt("21623627404")); // Toto je Moj Ad MAnager
});
